/* eslint-disable react/state-in-constructor, react/destructuring-assignment */
import React from 'react';

import { Typography } from '@mui/material';

import { Locale, TranslateFunc } from '@klokhuis/core/Intl/types';
import { NavLink } from '@klokhuis/core/Routing/NavLink';

import { ROUTES } from '../Routing';

import LogoIcon from '@klokhuis/icons/Logo.svg';

import styles from './ErrorBoundary.module.css';

import { reportError } from '.';

export interface ErrorBoundaryProps {
  children: React.ReactNode;
  locale: Locale;
  T: TranslateFunc;
}

export interface ErrorBoundaryState {
  hasError: boolean;
}

export class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  override state = {
    hasError: false,
  };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  override componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    reportError(error, {
      extra: { context: 'ErrorBoundary', metaData: errorInfo },
    });
  }

  override render() {
    if (this.state.hasError) {
      return (
        <div className={styles.root}>
          <NavLink.Anchor
            href={ROUTES.Home.url({})}
            className={styles.logoContainer}
          >
            <LogoIcon viewBox="0 0 82.88 15.35" />
          </NavLink.Anchor>
          <div className={styles.spacer} />
          <div className={styles.content}>
            <Typography variant="h4" className={styles.title}>
              {this.props.T('500_error_page.heading.oops')}
            </Typography>
            <Typography className={styles.paragraph} variant="body2">
              {this.props.T('500_error_page.body.tech_difficulties')}
            </Typography>

            <Typography
              className={styles.supportLink}
              variant="body2"
              dangerouslySetInnerHTML={{
                __html: this.props.T(
                  '500_error_page.body.tech_difficulties.refresh_page',
                  '',
                ),
              }}
            />
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
